import {
  WSButton,
  WSFlexBox,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";

import { queriesBackgroundChecks } from "@query";
import { BackgroundCheckStatus } from "@wingspanhq/wingspan-api-sdk";

import { NotificationTemplate } from "../index";
import { WSQueries } from "../../../../../query/WSQuery";
import React from "react";
import { useGoToDashboardPayerRequirementDetails } from "../../../routes/RouteRequirementDetails/RoutePayerRequirementDetails";
import { RequirementNotificationContext } from "../types";

const Body: React.FC<BackgroundCheckRequestContractorContext> = props => {
  const backgroundChecksRequestQuery =
    queriesBackgroundChecks.getBackgroundCheck.useQuery({
      backgroundCheckId: props.requirement.dataSourceId
    });

  return (
    <WSQueries queries={{ backgroundChecksRequestQuery }}>
      {({ backgroundChecksRequestQueryData }) => {
        const isNew =
          backgroundChecksRequestQueryData.status === BackgroundCheckStatus.NEW;

        return (
          <>
            Company <b>{props.payer.payerName}</b> has requested a background
            check <b>{props.requirement.requirementName}</b> to complete the
            onboarding process.
            {isNew ? (
              <>
                <br />
                You will receive an email with instructions shortly.
              </>
            ) : null}
          </>
        );
      }}
    </WSQueries>
  );
};

const Header: React.FC<BackgroundCheckRequestContractorContext> = props => {
  const backgroundChecksRequestQuery =
    queriesBackgroundChecks.getBackgroundCheck.useQuery({
      backgroundCheckId: props.requirement.dataSourceId
    });

  return (
    <WSQueries queries={{ backgroundChecksRequestQuery }}>
      {({ backgroundChecksRequestQueryData }) => {
        return (
          <WSFlexBox.CenterY wrap="nowrap">
            <WSText.Heading5 mr="M">Background check requested</WSText.Heading5>
            {backgroundChecksRequestQueryData.status ===
            BackgroundCheckStatus.NEW ? (
              <WSPill px="M" text="Pending" />
            ) : backgroundChecksRequestQueryData.status ===
              BackgroundCheckStatus.PENDING ? (
              <WSPill px="M" text="Action required" theme="warning" />
            ) : null}
          </WSFlexBox.CenterY>
        );
      }}
    </WSQueries>
  );
};

export type BackgroundCheckRequestContractorContext =
  RequirementNotificationContext;

export const BackgroundCheckRequestContractor: NotificationTemplate<BackgroundCheckRequestContractorContext> =
  {
    renderTitle: props => "Background check requested",
    Header: props => {
      return <Header {...props.context} />;
    },
    renderBody: props => {
      // if (props.group.length > 1) {
      //   return "Your clients requested background checks to complete the onboarding process.";
      // }

      return <Body {...props.context} />;
    },
    Footer: props => {
      const goToPayerRequirementDetails =
        useGoToDashboardPayerRequirementDetails();

      const backgroundChecksRequestQuery =
        queriesBackgroundChecks.getBackgroundCheck.useQuery({
          backgroundCheckId: props.context.requirement.dataSourceId
        });

      // const history = useHistory();
      //
      // if (props.group.length > 1) {
      //   return (
      //     <WSButton.Link
      //       size="S"
      //       rightIcon="chevron-right"
      //       onClick={() => {
      //         history.push("/member/dashboard/contractor-background-checks");
      //       }}
      //     >
      //       Open requests
      //     </WSButton.Link>
      //   );
      // } else
      //
      if (
        backgroundChecksRequestQuery.data?.status ===
        BackgroundCheckStatus.PENDING
      ) {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onAsyncClick={async () => {
              goToPayerRequirementDetails({
                requirementId: props.context.requirement.requirementId,
                payerId: props.context.payer.payerId
              });
            }}
          >
            Open <b>{props.context.requirement.requirementName}</b>
          </WSButton.Link>
        );
      } else {
        return null;
      }
    }
  };
